import React from 'react';
import { InputAdornment, IconButton, withStyles, StyledComponentProps, TextField as MuiTextField, InputProps, Input } from '@material-ui/core';
import { DeleteText as Clear } from '../../ui-components/Icons';
import { styles } from './styles';
import clsx from 'clsx';
import { Visibility, VisibilityOff } from '@material-ui/icons';

interface IProps extends StyledComponentProps {
    label?: string;
    value: string;
    onChange?: (val: string) => any;
    onBlur?: (val: string) => any;
    onFocus?: (e: any) => any;
    onKeyDown?: (e: any) => void;
    placeholder?: string;
    disabled?: boolean;
    rows?: number;
    multiline?: boolean;
    helperText?: string;
    type?: string;
    error?: boolean;
    InputProps?: Partial<InputProps>;
}
const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
};

const TextField = (props: IProps) => {
    const { classes, ...otherProps } = props;
    const { text, label, clearIcon, ...otherClasses } = classes;

    const [showPassword, setShowPassword] = React.useState(false);
    const [fieldType, setFieldTyle] = React.useState(props.type);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    // if (props.type === "password") {


    //     return (<Input
    //         id="standard-adornment-password"
    //         type={showPassword ? 'text' : 'password'}
    //         fullWidth
    //         color="secondary"
    //         {...{ ...otherProps, ...otherClasses }}
    //         onChange={(e) => props.onChange(e.target.value)}
    //         onBlur={(e) => props.onBlur && props.onBlur(e.target.value)}
    //         onFocus={(e) => props.onFocus && props.onFocus(e)}
    //         onKeyDown={(e) => props.onKeyDown && props.onKeyDown(e)}
    //         error={props.error}
    //         endAdornment={
    //             <InputAdornment position="end">
    //                 <IconButton
    //                     aria-label={
    //                         showPassword ? 'hide the password' : 'display the password'
    //                     }
    //                     onClick={handleClickShowPassword}
    //                     onMouseDown={handleMouseDownPassword}
    //                     onMouseUp={handleMouseUpPassword}
    //                 >
    //                     {showPassword ? <VisibilityOff /> : <Visibility />}
    //                 </IconButton>
    //             </InputAdornment>
    //         }
    //     />)

    // }
    // else

    const getFieldType = () => {
        // event.preventDefault();
        if (fieldType === "password") {
            return showPassword ? 'text' : 'password';
        }
        else
            return fieldType;
    };


    return (
        <MuiTextField
            fullWidth
            margin={"normal"}
            color="secondary"
            {...{ ...otherProps, ...otherClasses }}
            onChange={(e) => props.onChange(e.target.value)}
            onBlur={(e) => props.onBlur && props.onBlur(e.target.value)}
            onFocus={(e) => props.onFocus && props.onFocus(e)}
            onKeyDown={(e) => props.onKeyDown && props.onKeyDown(e)}

            //type={props.type}
            type={getFieldType()}

            error={props.error}
            helperText={props.helperText}
            multiline={props.multiline}
            rows={props.rows}
            InputProps={{
                ...props.InputProps,
                endAdornment: (fieldType === "password") ?
                    <InputAdornment position="end">
                        <IconButton
                            aria-label={
                                showPassword ? 'hide the password' : 'display the password'
                            }
                            style={{ color: '#1a171b', width: '0px', height: '0px' }}
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            onMouseUp={handleMouseUpPassword}
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment> : endIcon({ ...otherProps, clearIconClass: clearIcon }),
                className: (props.InputProps ? clsx(props.InputProps.className, text) : text),
            }}
            InputLabelProps={{
                className: label
            }}
        />

        // <FormControl fullWidth className={props.classes.root}>
        //     <InputLabel className={props.classes.label}>{props.label}</InputLabel>
        //     <Input
        //         inputProps={{ className: props.classes.text }}
        //         disabled={props.disabled}
        //         placeholder={props.placeholder}
        //         value={props.value}
        //         onChange={(e) => props.onChange(e.target.value)}
        //         endAdornment={endIcon(props)}
        //     >

        //     </Input>
        // </FormControl>
    );
}
const endIcon = (props: IProps & { clearIconClass: string }) => {
    if (props.disabled)
        return null;
    return (<InputAdornment position="end" variant='filled'>
        <IconButton
            aria-label="clear"
            onClick={(e) => props.onChange('')}
            onMouseDown={handleMouseDown}
            disableFocusRipple
            size='small'
            color='secondary'
        >
            <Clear className={props.clearIconClass} />
        </IconButton>
    </InputAdornment>)
}

export default withStyles(styles)(TextField);